import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getApi, postApi } from '../../services/apiServices';
import { toast } from 'react-toastify';
import Modal from 'react-modal';

function ViewCustomers() {
  const { user_id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [customerData, setCustomerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [emailForm, setEmailForm] = useState({
    email: '',
    subject: '',
    description: ''
  });
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('bundles');

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      border: 'none',
      borderRadius: '10px',
      padding: '0',
      maxWidth: '600px',
      width: '90%',
      backgroundColor: 'transparent'
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1000
    }
  };

  const fetchCustomerDetails = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await getApi(`/api/customer-details/${user_id}`);

      if (response?.status) {
        setCustomerData(response.data);

        setEmailForm({
          email: response.data.user?.email || '',
          subject: 'Special Offer',
          description: `Hello ${response.data.user?.name || 'Customer'}, Enjoy 20% off on your next top-up.`
        });
      } else {
        setError(response?.message || 'Failed to fetch customer details');
        toast.error(response?.message || 'Failed to fetch customer details');
      }
    } catch (error) {
      console.error('Error fetching customer details:', error);
      setError('Failed to fetch customer details. Please try again.');
      toast.error('Failed to fetch customer details. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    } catch (error) {
      return dateString;
    }
  };

  const handleEmailFormChange = (e) => {
    const { name, value } = e.target;
    setEmailForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const openEmailModal = () => {
    setShowEmailModal(true);
  };

  const closeEmailModal = () => {
    if (emailLoading) return;
    setShowEmailModal(false);
  };

  const handleSendEmail = async () => {
    try {
      setEmailLoading(true);

      if (!emailForm.email || !emailForm.subject || !emailForm.description) {
        toast.error('Please fill in all required fields');
        return;
      }

      const payload = {
        email: emailForm.email,
        subject: emailForm.subject,
        content: emailForm.description
      };

      const response = await postApi('/api/send-email', payload);

      if (response?.status) {
        toast.success(response.message || 'Email sent successfully');
        closeEmailModal();
        setEmailForm({
          email: customerData?.user?.email || '',
          subject: 'Special Offer',
          description: `Hello ${customerData?.user?.name || 'Customer'}, Enjoy 20% off on your next top-up.`
        });
      } else {
        toast.error(response?.message || 'Failed to send email');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      toast.error(error?.message || 'Failed to send email. Please try again.');
    } finally {
      setEmailLoading(false);
    }
  };

  useEffect(() => {
    if (user_id) {
      fetchCustomerDetails();
    }
  }, [user_id]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('openEmailModal') === '1') {
      setShowEmailModal(true);
    }
    const tab = params.get('tab');
    if (tab && ['bundles', 'usage', 'payments'].includes(tab)) {
      setActiveTab(tab);
    }
  }, [location.search]);

  const handleBackClick = (e) => {
    e.preventDefault();
    navigate('/admin/customers');
  };

  if (loading) {
    return (
      <div className="right-section">
        <div className="loader-overlay">
          <span className="loader"></span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="right-section">
        <div className="error-container">
          <p>{error}</p>
          <button onClick={fetchCustomerDetails} className="retry-btn">
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="right-section view-cs-page">
        <div className="view-heading">
          <ul>
            <li>
              <a href="" className="active" onClick={handleBackClick}>
                <img src={window.getPublicUrl('admin/images/back-button.svg')} /> Back to customer
              </a>
            </li>
          </ul>
        </div>

        {/* ---------profile details--------- */}

        <div className="profile-data">
          <div className="row">
            <div className="col-md-3">
              <ul className="user-data">

                <li>
                  <span className="profile-img">
                    <img src={customerData?.user?.profile_picture || window.getPublicUrl('admin/images/profile.svg')} alt="profile" />
                  </span>
                  <h3 className="profile-haeding">{customerData?.user?.name || 'N/A'}</h3>

                </li>
              </ul>
            </div>
            <div className="col-md-4">
              <div className="inner-profile-data">
                <ul className="user-list-data">
                  <li>
                    <p>Email</p>
                    <span>
                      <img src={window.getPublicUrl('admin/images/line.svg')} alt="" />
                    </span>
                    <h4>{customerData?.user?.email || 'N/A'}</h4>
                  </li>
                  <li>
                    <p>Join Date</p>
                    <span>
                      <img src={window.getPublicUrl('admin/images/line.svg')} alt="" />
                    </span>
                    <h4>{formatDate(customerData?.user?.join_date)}</h4>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-3">
              <ul className="user-list-data dates-details">

                <li>
                  <p>Last Login</p>
                  <span>
                    <img src={window.getPublicUrl('admin/images/line.svg')} alt="" />
                  </span>
                  <h4>{formatDate(customerData?.user?.last_login)}</h4>
                </li>
              </ul>
            </div>
            <div className="col-md-2">
              <div className="button-seetings">
                <button className="btn send-email" onClick={openEmailModal}>
                  Send Email
                </button>

                <Modal
                  isOpen={showEmailModal}
                  onRequestClose={emailLoading ? undefined : closeEmailModal}
                  style={customStyles}
                  contentLabel="Send Email Modal"
                >
                  <div className="paymentsuccess send-email-modal">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Send Email</h5>
                        <button
                          type="button"
                          className="close"
                          onClick={closeEmailModal}
                          aria-label="Close"
                          disabled={emailLoading}
                        >
                          <img src={window.getPublicUrl('admin/images/close-icon.svg')} alt="" />
                        </button>
                      </div>
                      <div className="modal-body">
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label>Email</label>
                              <input
                                type="email"
                                className="form-control"
                                placeholder="admin@travelsim.com"
                                name="email"
                                value={emailForm.email}
                                onChange={handleEmailFormChange}
                              />
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label>Subject</label>
                              <div className="select-option w-100">
                                <select
                                  name="subject"
                                  className="w-100"
                                  value={emailForm.subject}
                                  onChange={handleEmailFormChange}
                                >
                                  <optgroup label="Swedish Cars">
                                    <option value="Special Offer">Special Offer</option>
                                    <option value="Special Offer">Special Offer</option>
                                  </optgroup>

                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label>Description</label>
                              <textarea
                                className="w-100"
                                name="description"
                                rows="5"
                                value={emailForm.description}
                                onChange={handleEmailFormChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-cancel" onClick={closeEmailModal}>
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-save"
                          onClick={handleSendEmail}
                          disabled={emailLoading}
                        >
                          {emailLoading ? 'Sending...' : 'Send Email'}
                        </button>
                      </div>
                    </div>
                  </div>
                </Modal>
              </div>
            </div>
          </div>
        </div>

        {/* ---------table--------- */}

        <div className="profile-table-data">
          <div className="customer-top">
            <div className="customer-top-left">
              <ul>
                <li>
                  <a
                    href="#"
                    className={activeTab === 'bundles' ? 'active' : ''}
                    onClick={e => { e.preventDefault(); setActiveTab('bundles'); }}
                  >
                    Bundles
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className={activeTab === 'usage' ? 'active' : ''}
                    onClick={e => { e.preventDefault(); setActiveTab('usage'); }}
                  >
                    Usage
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className={activeTab === 'payments' ? 'active' : ''}
                    onClick={e => { e.preventDefault(); setActiveTab('payments'); }}
                  >
                    Payments
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className={`customer-tablle-main ${activeTab === 'bundles' ? 'bundle' : activeTab === 'usage' ? 'usage' : activeTab === 'payments' ? 'payment' : ''}`}>
            {activeTab === 'bundles' && (
              <table className="table">
                <thead>
                  <tr>
                    <th className="name" scope="col">
                      Bundle Name
                    </th>
                    <th scope="col" className="region">
                      Region
                    </th>
                    <th scope="col" className="price">
                      Price
                    </th>
                    <th scope="col" className="status">
                      Status
                    </th>
                    <th scope="col" className="purchase-date">
                      Purchase Date
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {customerData?.bundles_purchased && customerData.bundles_purchased.length > 0 ? (
                    customerData.bundles_purchased.map((bundle, index) => (
                      <tr key={index}>
                        <td className="name">
                          <span className="profile-img">
                            <img src={bundle.flag || window.getPublicUrl('admin/images/global.svg')} alt={bundle.region || 'Global'} />
                          </span>
                          {bundle.bundle_name || 'N/A'}
                        </td>
                        <td className="region">{bundle.region || 'N/A'}</td>
                        <td className="price">{bundle.price || 'N/A'}</td>
                        <td className="status">
                          <button
                            className={`btn btn-status ${bundle.status === 'active'
                              ? 'btn-status-active' : bundle.status === 'inactive'
                                ? 'btn-status-terminate'
                              : bundle.status === 'terminated'
                                ? 'btn-status-terminate'
                                : 'btn-status-primary'
                              }`}
                          >
                            <img
                              src={
                                bundle.status === "active"
                                  ? window.getPublicUrl("admin/images/dot.svg")
                                  : bundle.status === "inactive"
                                    ? window.getPublicUrl("admin/images/terminate.svg")
                                    : bundle.status === "terminated"
                                      ? window.getPublicUrl("admin/images/terminate.svg")
                                      : window.getPublicUrl("admin/images/default.svg")
                              }
                              alt="status"
                              className="btn-icon"
                            />

                            {bundle.status || 'Action'}
                          </button>

                        </td>
                        <td className="purchase-date">{formatDate(bundle.purchased_date)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No bundles purchased yet
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
            {activeTab === 'usage' && (
              <div>
                {customerData?.bundles_purchased && customerData.bundles_purchased.length > 0 ? (
                  customerData.bundles_purchased.map((bundle, idx) => {
                    const total = parseFloat(bundle.package_data?.total_data_gb) || 0;
                    const used = parseFloat(bundle.package_data?.used_data_gb) || 0;
                    const remaining = parseFloat(bundle.package_data?.remaining_data_gb) || 0;
                    const percentUsed = total ? Math.round((used / total) * 100) : 0;
                    return (
                      <div className="progress-bar-data" key={idx}>
                        <h6 className="mb-4">{bundle.bundle_name}</h6>
                        <div className="d-flex justify-content-between mb-2">
                          <p>Total Data: <strong>{total} GB</strong></p>
                          <p>Used Data: <strong>{used} GB</strong></p>
                        </div>
                        <div className="progress">
                          <div
                            className="progress-bar"
                            style={{ width: `${percentUsed}%` }}
                            role="progressbar"
                            aria-valuenow={percentUsed}
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                        <div className="d-flex justify-content-between mt-2">
                          <p>Remaining Data: <strong>{remaining} GB</strong></p>
                          <p>Valid Till: <strong>{bundle.package_data?.valid_till || '-'}</strong></p>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className='no-data-usage'>
                    <p>No usage data available.</p>
                  </div>
                )}
              </div>
            )}
            {activeTab === 'payments' && (
              <div className='no-data-payment'>
                {customerData?.payments && customerData.payments.length > 0 ? (
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Order ID</th>
                        <th>Amount</th>
                        <th>Date</th>
                        <th>Method</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {customerData.payments.map((payment, idx) => (
                        <tr key={idx}>
                          <td>{payment.id}</td>
                          <td>{payment.amount}</td>
                          <td>{formatDate(payment.date)}</td>
                          <td>{payment.payment_method || 'N/A'}</td>
                          <td className='unpaid'>{payment.status}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No payments found.</p>
                )}
              </div>
            )}
          </div>
        </div>

        {/* ---------notes--------- */}

        {/* <div className="profile-table-data notes">
    <div className="add-note">
      <p>No note added yet for this customer.</p>
      <button className="btn note-btns">+ Add Note</button>
      <p className="description-notes">
        Lorem Ipsum is simply dummy text of the printing and typesetting industry...
      </p>
      <div className="row add-new-notes footer-data">
        <div className="col-md-8">
          <div className="row">
            <div className="col-md-3">
              <div className="user-list-data d-flex align-items-center justify-content-between">
                <p>Added By Admin</p>
                <span>
                  <img src="images/line.svg" alt="" />
                </span>
                <h4>Adam Smith</h4>
              </div>
            </div>
            <div className="col-md-3">
              <div className="user-list-data d-flex align-items-center justify-content-between">
                <p>Added By Admin</p>
                <span>
                  <img src="images/line.svg" alt="" />
                </span>
                <h4>Adam Smith</h4>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 text-right">
          <button className="btn note-btns">Edit</button>
        </div>
      </div>
      <textarea name="story" rows="22" className="w-100 mx-auto">
        Type note...
      </textarea>
      <div className="row add-new-notes footer-data">
        <div className="col-md-12">
          <div className="footer-btn-settings">
            <button className="btn cancel-btn">Cancel</button>
            <button className="btn save-btn">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div> */}
      </div>


    </>
  );
}

export default ViewCustomers;
